import type { TranslationTree } from '../../types';

export const common: TranslationTree = {
  common: {
    brand: 'ToolLife',
    loading: 'Wird geladen…',
    close: 'Schließen',
    clearSelection: 'Auswahl löschen',
    required: 'erforderlich',
    retry: 'Erneut versuchen',
    confirm: 'Bestätigen',
    delete: 'Löschen',
    remove: 'Entfernen',
    removeItem: '{{item}} entfernen',
    breadcrumb: 'Brotkrumennavigation',
    back: 'Zurück',
    search: 'Suchen',
    notProvided: 'Nicht angegeben',
    loadingShort: 'Wird geladen…',
    cancel: 'Abbrechen',
    chooseTheme: 'Thema auswählen',
    themeLight: 'Hell',
    themeDark: 'Dunkel',
    reference: 'Referenz',
    logoAlt: 'Louis Bélet Logo',
  },
  form: {
    validation: {
      requiredTooltip: 'Dieses Feld ist erforderlich.',
      requiredMultiTooltip: 'Mindestens ein Feld mit einem orangen * muss ausgefüllt werden.',
      requiredMultiAtLeastOne: 'Mindestens ein Feld muss ausgefüllt werden.',
      checkboxAtLeastOne: 'Bitte wählen Sie mindestens eine Option aus.',
    },
    numberInput: {
      increase: 'Wert erhöhen',
      decrease: 'Wert verringern',
    },
    select: {
      options: 'Wählen Sie eine Option',
    },
  },
};
